import { createGlobalStyle } from 'styled-components';

// theme.js
export const lightTheme = {
    body: '#fff',
    text: "#091236",
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    logoBg : '',
  }
  
  export const darkTheme = {
    body: "#072541",
    text: '#ffffffd1',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    logoBg : "#F3F3F3"
  }

export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    // font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    // transition: all 0.25s linear;
  }

  // a {
  //   color: ${({ theme }) => theme.text};
  // }

    a.nav-link {
      color : ${({ theme }) => theme.logoBg}!important;
    }

  .section-logo {
    background: ${({ theme }) => theme.logoBg};
    border-radius: 15px;
  }

`;